import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// createClient(undefined, undefined) throws synchronously at module
// load, which whitescreens the entire app before React can mount.
// Guard the call and export null when env vars are missing. Every
// consumer must check `if (!supabase) return;` before use — the
// existing useMatchChat and Navbar already do.
let _client = null;
if (SUPABASE_URL && SUPABASE_ANON_KEY) {
  try {
    _client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
  } catch (e) {
    console.error("[supabase] client init failed:", e);
    _client = null;
  }
} else {
  console.warn(
    "[supabase] REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY not set — realtime disabled",
  );
}

export const supabase = _client;